import { CdkDragDrop, CdkDragStart, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { EventResource } from 'src/app/interfaces/event-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { ContractService } from 'src/app/services/contract.service';
import { EventService } from 'src/app/services/event.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { PropertyService } from 'src/app/services/property.service';

@Component({
  selector: 'app-advent-calendar',
  templateUrl: './advent-calendar.component.html',
  styleUrls: ['./advent-calendar.component.scss']
})
export class AdventCalendarComponent implements OnInit {
  loading: boolean = true;

  avalibleEvents_Advent = [];
  inUseEvents_Advent = [];
  allEvents_Advent = [];

  allEvents = [];

  dragging: boolean = false;

  constructor(
    private contractService: ContractService,
    private eventService: EventService,
    private propertyService: PropertyService,
    private overlayService: OverlayService
  ) {

  }

  ngOnInit() {
    combineLatest([
      this.contractService.has_adventCalender$,
      this.eventService.getEventsForCampaigns(0, 999),
      this.propertyService.getAdventEventIDs(),
    ]).pipe(
      map(([hasCalendar, events, eventIDs]: [any, PagedResources<any>, any]) => {
        console.log(hasCalendar, events, eventIDs)
        let tempEventIDs = JSON.parse(eventIDs.value)
        this.allEvents = events.content;
        if(tempEventIDs != null){
          events.content.forEach((element: EventResource) => {
            tempEventIDs.forEach((component_web_landing_page, index) => {
              if (element.publicId == component_web_landing_page) {
                let number = index;
                if (number.length < 2) {
                  element["NUMBER"] = "0" + number
                } else {
                  element["NUMBER"] = number
                }
                this.inUseEvents_Advent.push(element);
              }
            });
            //Sort Elements
            this.inUseEvents_Advent.sort((a, b) => (a['NUMBER'] > b['NUMBER']) ? 1 : -1);
          })
          this.avalibleEvents_Advent = this.allEvents.filter(x => !this.inUseEvents_Advent.includes(x));
        }else{
          this.avalibleEvents_Advent = this.allEvents.filter(x => !this.inUseEvents_Advent.includes(x));
        }
     

      })
    ).subscribe(() => {
      this.loading = false;
    })
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  public handleDragStart(event: CdkDragStart): void {
    this.dragging = true;
  }

  deltefromListAdvents(event: MouseEvent, e: EventResource) {
    if (this.dragging) {
      this.dragging = false;
      return
    }
    this.inUseEvents_Advent.splice(this.inUseEvents_Advent.indexOf(e), 1)
    this.avalibleEvents_Advent.push(e)
  }

  addToListAdvents(event: MouseEvent, e: EventResource) {
    if (this.dragging) {
      this.dragging = false;
      return
    }
    this.avalibleEvents_Advent.splice(this.avalibleEvents_Advent.indexOf(e), 1)
    this.inUseEvents_Advent.push(e)
  }

  updateAdventTiles() {
    //Comvert String to the necessary fornat
    //Example Sting for changeing the advertising
    //let value = "[\"4ed47d2b-4209-4236-a9d4-a6f75166228c\",\"571d6080-3dca-40d3-ad17-2eb01370d3fd\"]";
    let temp = "[";
    this.inUseEvents_Advent.forEach((element: EventResource, index) => {
      if (index == this.inUseEvents_Advent.length - 1) {
        temp += '\"' + element.publicId + "\"]";
      } else {
        temp += '\"' + element.publicId + '\",';
      }
    });
    if (this.inUseEvents_Advent.length == 0) {
      this.propertyService.updateProperty("component_advent", "[]").subscribe(value => {
        console.log("value Update", value)
        this.overlayService.openSnackBar("Adventskalender erfolgreich bearbeitet!")
      })
    } else {
      this.propertyService.updateProperty("component_advent", temp).subscribe(value => {
        console.log("value Update", value)
        this.overlayService.openSnackBar("Adventskalender erfolgreich bearbeitet!")
      })
    }


  }

}
